import { render } from "./tugasPokok.vue?vue&type=template&id=7462f2ea"
import script from "./tugasPokok.vue?vue&type=script&lang=js"
export * from "./tugasPokok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__